import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__grid">
        <section className="footer-brand">
          <h2>
            Considered for today.
            <br />
            Made for the long run.
          </h2>
          <p>
            nartvmora designs considered denim and wardrobe staples with
            longevity at their core.
          </p>
          <Link to="/shop" className="text-link">
            Shop all
          </Link>
        </section>

        <details className="footer-links" open>
          <summary>Explore</summary>
          <Link to="/about">About us</Link>
          <Link to="/shop">Shop all</Link>
          <Link to="/shop?sort=newest">New arrivals</Link>
          <Link to="/shop?sale=true">Final sale</Link>
        </details>
        <details className="footer-links" open>
          <summary>Customer care</summary>
          <Link to="/fit-guide">Fit guide</Link>
          <Link to="/shipping">Shipping & delivery</Link>
          <Link to="/returns">Returns & refunds</Link>
          <Link to="/orders">Orders & cancellations</Link>
          <Link to="/payments">Payments & billing</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/faqs">FAQs</Link>
        </details>
        <details className="footer-links" open>
          <summary>Legal & policies</summary>
          <Link to="/policies">All policies</Link>
          <Link to="/sale-policy">Sale & promotions</Link>
          <Link to="/consumer-guarantees">Consumer guarantees</Link>
          <Link to="/terms">Terms of use</Link>
          <Link to="/privacy">Privacy notice</Link>
          <Link to="/privacy-choices">Privacy choices</Link>
          <Link to="/cookies">Cookie policy</Link>
          <Link to="/acceptable-use">Acceptable use</Link>
          <Link to="/accessibility">Accessibility</Link>
          <Link to="/intellectual-property">IP & takedown</Link>
        </details>
        <details className="footer-links" open>
          <summary>Contact</summary>
          {/* <address className="footer-contact">
            <a href="mailto:service@nartvmora.site">service@nartvmora.site</a>
            <span>116 Jln Kuras, Singapore 577782</span>
          </address> */}
          <p>
            LiFa Wang
            <br />
            w444750922@sina.com
            <br />
            ChangBaiZhen
            <br />
            TongJiangWeiYiZu
            <br />
            ChangBaiChaoXianZuZiZhiXian
            <br />
            134400
            <br />
            China
            <br />
            Call us: +86 18469658324
          </p>
          <Link to="/policies">Policy centre</Link>
        </details>
      </div>
      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} nartvmora ·{" "}
          <a href="mailto:service@nartvmora.site">service@nartvmora.site</a>
        </span>
        <div className="payment-methods" aria-label="Supported payment methods">
          <span>Visa</span>
          <span>Mastercard</span>
          <span>American Express</span>
          <span>UnionPay</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
